// Expects '?stuff=things&stuff2=things2' from react-router location.search props
export default function parseQueryString(
  urlFragment: string,
): { [param: string]: string | undefined } {
  if (!urlFragment) {
    return {};
  }
  const queryString = urlFragment.split('?')[1];
  if (!queryString) {
    return {};
  }

  const keyAndValuePairStrings = queryString.split('&');
  const parsedParams = {};
  keyAndValuePairStrings.forEach(keyAndValuePairString => {
    if (!keyAndValuePairString) {
      return;
    }
    const keyAndValuePair = keyAndValuePairString.split('=');
    const key = keyAndValuePair[0] && decodeURIComponent(keyAndValuePair[0]);
    if (!key || key === 'password') {
      return;
    }
    // Okay if it's undefined.
    const value = keyAndValuePair[1] && decodeURIComponent(keyAndValuePair[1]);
    parsedParams[key] = value;
  });
  return parsedParams;
}
